import { AnimationLayout, BottomNavigation, ScrollToTop } from '@/components';
import { APP_ROUTES } from '@/config/constants';
import useProfile from '@/hooks/useProfile';
import {
  Account,
  AccountInformationContainer,
  Community,
  CommunityFreeFlyerboard,
  Explore,
  ExploreAllFlyerboard,
  ExploreNewFlyers,
  ExploreResults,
  FlyerDetails,
  Help,
  Home,
  Language,
  Maps,
  Notifications,
  OrgProfile,
  Preference,
  Saved,
  Search,
  UpcomingContainer,
} from '@/pages';
import { pathMatches } from '@/utils/pathMatches';
import { css } from '@emotion/css';
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import SpinnerOverlay from './components/SpinnerOverlay/SpinnerOverlay';
import { useSubscription } from './hooks';
import { useGetMyDistrict } from './hooks/useGetMyDistrict';

function AutenticatedLayout() {
  const { pathname } = useLocation();
  const { loading: loadingUser } = useProfile();
  const { loading: getDistrictLoading } = useGetMyDistrict();
  const { loading: getSubscriptionLoading } = useSubscription();
  const [loading, setLoading] = useState<boolean>(true);
  const { flyerDetails, oldFlyerDetails, orgProfile, maps } = APP_ROUTES;

  useEffect(() => {
    if (!getSubscriptionLoading && !getDistrictLoading && !loadingUser) {
      setLoading(false);
    }
  }, [getSubscriptionLoading, getDistrictLoading, loadingUser]);

  const hideBottomNavPaths = [flyerDetails, oldFlyerDetails, orgProfile, maps];
  const shouldShowBottomNav = !pathMatches(pathname, hideBottomNavPaths);

  if (loading) {
    return (
      <SpinnerOverlay
        loading={loading}
      />
    );
  }
  return (
    <div className={styles.app}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <ScrollToTop>
            <Routes>
              <Route element={<AnimationLayout />}>
                <Route path={APP_ROUTES.home} element={<Home />} />
                <Route
                  path={APP_ROUTES.upcoming}
                  element={<UpcomingContainer />}
                />
                <Route path={APP_ROUTES.explore}>
                  <Route index element={<Explore />} />
                  <Route path={APP_ROUTES.search} element={<Search />} />
                  <Route
                    path={APP_ROUTES.exploreResults}
                    element={<ExploreResults />}
                  />
                  <Route
                    path={APP_ROUTES.exploreAllFlyers}
                    element={<ExploreAllFlyerboard />}
                  />
                  <Route
                    path={APP_ROUTES.exploreNewFlyers}
                    element={<ExploreNewFlyers />}
                  />
                </Route>
                <Route path={APP_ROUTES.saved} element={<Saved />} />
                <Route
                  path={APP_ROUTES.flyerDetails}
                  element={<FlyerDetails />}
                />
                <Route
                  path={APP_ROUTES.oldFlyerDetails}
                  element={<FlyerDetails />}
                />
                <Route path={APP_ROUTES.orgProfile} element={<OrgProfile />} />
                <Route path={APP_ROUTES.account}>
                  <Route index element={<Account />} />
                  <Route
                    path={APP_ROUTES.accountInformation}
                    element={<AccountInformationContainer />}
                  />
                  <Route path={APP_ROUTES.preference}>
                    <Route index element={<Preference />} />
                    <Route path={APP_ROUTES.language} element={<Language />} />
                    <Route
                      path={APP_ROUTES.notifications}
                      element={<Notifications />}
                    />
                    <Route
                      path={APP_ROUTES.community}
                      element={<Community />}
                    />
                  </Route>
                  <Route path={APP_ROUTES.help} element={<Help />} />
                </Route>
                <Route
                  path={APP_ROUTES.commFreeFlyerboard}
                  element={<CommunityFreeFlyerboard />}
                />
              </Route>
              <Route path={APP_ROUTES.maps} element={<Maps />} />
            </Routes>
          </ScrollToTop>
        </div>
      </div>
      {shouldShowBottomNav && <BottomNavigation />}
    </div>
  );
}

const styles = {
  app: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
    @media screen {
      background: #f5f5f5;
    }
  `,
  wrapper: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    @media screen {
      align-items: center;
    }
  `,
  content: css`
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    max-width: 748px;
    width: 100%;
    @media screen {
      background: #fff;
    }
  `,
};

export default AutenticatedLayout;
